import React from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

const num = (v) => { const n = parseFloat(v); return Number.isFinite(n) ? n : undefined; };
const bp = (v = '') => { const m = String(v).match(/(\d{2,3})\s*\/\s*(\d{2,3})/); return m ? [Number(m[1]), Number(m[2])] : [undefined, undefined]; };

const SERIES = [
  ['systolic', 'BP systolic', '#b91c1c'], ['diastolic', 'BP diastolic', '#f87171'], ['pulse', 'Pulse', '#1d4ed8'],
  ['o2', 'O2 %', '#0f766e'], ['temp', 'Temp', '#a16207'], ['pain', 'Pain (0-10)', '#7c3aed'],
];

export const VitalsTrend = ({ notes }) => {
  const rows = [...notes].filter(n => n.vitals && Object.keys(n.vitals).length)
    .sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1))
    .map(n => {
      const [systolic, diastolic] = bp(n.vitals.bp);
      const t = new Date(n.createdAt);
      return { label: `${t.getMonth() + 1}/${t.getDate()} ${t.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}`, systolic, diastolic, pulse: num(n.vitals.pulse), o2: num(n.vitals.o2), temp: num(n.vitals.temp), pain: num(n.vitals.pain) };
    });
  if (rows.length === 0) return <p className="text-sm text-gray-500 mb-3" data-testid="vitals-trend-empty">No vitals recorded yet. Vitals from visit notes will chart here.</p>;
  const shown = SERIES.filter(([k]) => rows.some(r => r[k] !== undefined));
  return (
    <div className="mb-4" data-testid="vitals-trend">
      <p className="text-sm font-medium text-gray-700 mb-2">Vitals trend ({rows.length} note{rows.length > 1 ? 's' : ''} with vitals)</p>
      <div className="h-64 w-full">
        <ResponsiveContainer>
          <LineChart data={rows} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
            <XAxis dataKey="label" fontSize={12} />
            <YAxis fontSize={12} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {shown.map(([k, label, color]) => <Line key={k} type="monotone" dataKey={k} name={label} stroke={color} strokeWidth={2} dot={{ r: 3 }} connectNulls />)}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
